<template>
    <div style="background:rgb(252, 252, 252);" class="index-banner">
        <swiper :options="swiperOption" ref="mySwiper">
            <swiper-slide class="swiper-slide" v-for="(item,index) in list" :key="index">
                <div class="banneritem" :style="{backgroundImage:'url('+item.image+')'}" @click="todetail(item)"></div>
            </swiper-slide>
            <!-- 分页器 -->
            <div class="swiper-pagination indexpage"  slot="pagination" v-if="list.length > 0"></div>
        </swiper>
    </div>
</template>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
.banneritem{
    width: 100%;
    height: 400px;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    cursor: pointer;

}
</style>
<style type="text/css" lang="scss">
    .index-banner {
        .swiper-pagination-bullet{
            width: 8px;
            height: 8px;
            background: #E5E5E5;
            border-radius: 4px;
            &.swiper-pagination-bullet-active{
                width: 16px;
                height: 8px;
                background: #76E2D2;
                border-radius: 4px;
                
            }

            
        }
        
        .swiper-pagination-fraction,.swiper-pagination-custom,.swiper-container-horizontal > .swiper-pagination-bullets{
                right:62px;
                bottom:24px;
                transform: translateX(0);
                left:auto;
                width: auto
        
        }
        
        
        
    }


</style>
<script>
import { myMixin } from '@/mixin/mixin.js'

export default {
    name: 'banner',
    props: {
        list:Array
        
    },
    components: {

    },
    mixins: [myMixin],
    data() {
        return {
            bannerArr:[
                {
                    url:'https://w2.fishqc.net/image/cache/catalog/fangyi-pc-1920x424.png',
               
                },
                {
                    url:'https://w2.fishqc.net/image/cache/catalog/gouliang/banner-1920x424-1920x424.png',
                 
                },
                {
                    url:'https://w2.fishqc.net/image/cache/catalog/fangyi-pc-1920x424.png',
               
                }
            ],
            swiperOption:{
                //显示分页
                pagination: {
                  el: '.swiper-pagination'
                },
                //自动轮播
                autoplay: {
                    delay: 2000,
                      //当用户滑动图片后继续自动轮播
                    disableOnInteraction: false,
                },
                //开启循环模式
                loop: false,
                
            }
        }
    },
    methods: {
        choosetab(item) {},
        todetail(item){
            switch(item.targetType){
                case '1':   //榜单
                    this.$router.push({
                        path: '/rank/detail/'+item.targetId
                    })
                break;
                case '2':   //报告
                    this.$router.push({  
                        path: '/report/detail/'+item.targetId

                    })
                break;
                case '3':  //榜单专题
                    if(item.urlPc){
                        window.location.href = item.urlPc
                    }

                break;
                case '4':   //文章
                    this.$router.push({  
                        path: '/article/detail/'+item.targetId

                    })
                break;

            }
            
            
        }
    },
    computed: {
        swiper() {
            return this.$refs.mySwiper.$swiper
        }
    },
    mounted() {
        
      console.log('Current Swiper instance object', this.swiper)
      this.swiper.slideTo(0, 2000, false)
    }
}
</script>